/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{t}from"../../chunks/mat4.js";function n(t,n,o){const s=Math.sin(t),r=Math.cos(t),a=Math.sin(n),c=Math.cos(n),h=o;return h[0]=-s,h[4]=-a*r,h[8]=c*r,h[12]=0,h[1]=r,h[5]=-a*s,h[9]=c*s,h[13]=0,h[2]=0,h[6]=c,h[10]=a,h[14]=0,h[3]=0,h[7]=0,h[11]=0,h[15]=1,h}function o(o,s,r){return n(o,s,r),t(r,r),r}export{n as computeENUToSphericalPCPFLocalRotation,o as computeSphericalPCPFToENULocalRotation};
